import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Feather from '@expo/vector-icons/Feather';

const InfowaningBox = ({ red, text, children }) => {
  return (
    <View style={red ? styles.warningBox : styles.infoBox}>
      
      {/* Left Icon */}
      <Feather
        name="info"
        size={22}
        color={red ? "rgb(229, 77, 64)" : "#007acc"}
        style={{ marginRight: 10, marginTop: 3 }}
      />

      {/* Right Content */}
      <View style={{ flex: 1 }}>
        {text ? <Text style={styles.text}>{text}</Text> : null}

        {/* Children Content */}
        {children}
      </View>

    </View>
  );
};

const styles = StyleSheet.create({
  infoBox: {
    padding: 14,
    backgroundColor: '#e6f4ff',
    borderRadius: 12,
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  warningBox: {
    padding: 14,
    backgroundColor: 'rgba(255, 86, 72, 0.12)',
    borderRadius: 12,
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  text: {
    color: "#333",
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 10,
  },
});

export default InfowaningBox;